import isNull from 'lodash/isNull'
import { call, select, takeLatest } from 'redux-saga/effects'

import managers from '../../lib/managers'
import PaperManager from '../../lib/managers/PaperManager'
import { Overlay } from '../../lib/toolBoxes/2D/tools'
import {
    DEFAULT_OVERLAY_COLOR,
    selectOpacityDict,
    selectOverlayColorDict,
    updateClassificationOverlaidChunkId,
} from '../../slices/2D'
import { NormalizedDocumentChunk, selectNormalizedDocumentChunks } from '../../slices/documents'

export function* handleInsertingClassificationOverlay(action: ReturnType<typeof updateClassificationOverlaidChunkId>) {
    const manager: PaperManager | null = yield call(managers.get2DManager)

    if (isNull(manager)) return

    const overlayTool: Overlay = yield call(manager.getTool, Overlay.NAME)

    if (action.payload === null) {
        yield call(overlayTool.resetOverlayRasters)
        yield call(overlayTool.resetSelectedImagesAndCrossHairs)

        return
    }

    const normalizedChunks: NormalizedDocumentChunk[] = yield select(selectNormalizedDocumentChunks)
    const chunkOpacityDict: Record<number, number> = yield select(selectOpacityDict)
    const possibleChunk: NormalizedDocumentChunk | undefined = normalizedChunks.find(
        (docChunk) => docChunk.id === action.payload
    )

    const overlayColorDict: Record<number, string> = yield select(selectOverlayColorDict)

    if (!possibleChunk) return

    const { src } = possibleChunk
    const overlayColor: string = overlayColorDict[possibleChunk.id] ?? DEFAULT_OVERLAY_COLOR
    const chunkOpacity: number = isFinite(chunkOpacityDict[possibleChunk.id])
        ? chunkOpacityDict[possibleChunk.id] / 100
        : Overlay.DEFAULT_OPACITY

    yield call(overlayTool.insertOverlay, src, possibleChunk.id, chunkOpacity, overlayColor, true)
    yield call(overlayTool.activate)
    yield call(overlayTool.lockOverlay, false)
}

export function* watchForSelectingClassificationOverlay() {
    yield takeLatest(updateClassificationOverlaidChunkId.type, handleInsertingClassificationOverlay)
}
